import { render, staticRenderFns } from "./Login.FinishRegister.vue?vue&type=template&id=76b56cae&scoped=true&"
import script from "./Login.FinishRegister.vue?vue&type=script&lang=js&"
export * from "./Login.FinishRegister.vue?vue&type=script&lang=js&"
import style0 from "./Login.FinishRegister.vue?vue&type=style&index=0&id=76b56cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b56cae",
  null
  
)

export default component.exports